// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U_Kz","colBig":"styles_colBig__1_3yi","colSmall":"styles_colSmall__1h0rE"};